<section class="relative w-dvw p-2">
  <div
    class="fixed inset-0 min-h-[100vh] bg-gradient-to-b from-blue to-white from-15% to-50%"
  ></div>

  <div class="relative overflow-y-auto p-1">
    <app-header />

    <div class="contents text-light-black">
      <ng-content></ng-content>
    </div>

    <app-navigation-bar />
  </div>
</section>
